// Module
var code = "<div id=\"V-AFD3D523-F36A-4CCE-A98B-A515A46ABD56\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\" data-b-comp-allowsuggestion=\"true\" data-b-comp-suggestionsseparator=\"&nbsp\" data-b-comp-suggestions=\"{Binding suggestions}\"></div> </div> ";
// Exports
export default code;